module.exports = __webpack_public_path__ + "img/banner.431e3db2.jpg";